import { useInsuranceHandler } from '@hooks/useInsuranceHandler';
import { BoilerInsuranceQuote } from '@src/types/insurance';

import { deselectBhcQuoteMutation, selectBhcQuoteMutation } from './query';
import { useTrackBhcSelected } from './useTrackBhcSelected';

const useBoilerHomeCoverHandler = (
  quote: BoilerInsuranceQuote,
  basketId: string,
  onSelectCompleted?: () => void,
  onDeselectCompleted?: () => void
) => {
  const { trackCoverSelected } = useTrackBhcSelected();

  return useInsuranceHandler({
    quoteId: quote.id,
    basketId,
    selectMutation: selectBhcQuoteMutation,
    deselectMutation: deselectBhcQuoteMutation,
    onSelected: trackCoverSelected,
    onSelectCompleted,
    onDeselectCompleted,
  });
};

export { useBoilerHomeCoverHandler };
